import Button from "../../../common/components/input/Button/Button";
import FlexColumn from "../../../common/components/layout/Flexbox/FlexColumn";
import FlexRow from "../../../common/components/layout/Flexbox/FlexRow";
import TextInput from "../../../common/components/input/TextInput/TextInput";

import { useState } from "react";

type ArticleProperty = {
    key: string;
    value: string;
};

type Props = {
    properties: ArticleProperty[];
    onUpdatePropertyValue?: (key: string, value: string) => void;
    onRemoveProperty?: (key: string) => void;
    onAddProperty?: (key: string) => void;
    onPropertyDataChanged?: (value: ArticleProperty[]) => void;
};

export default function ArticlePropertiesEditControl({
    properties,
    onPropertyDataChanged,
}: Props): JSX.Element {
    const [newPropertyText, setNewPropertyText] = useState<string>("");

    return (
        <FlexColumn gap={8}>
            {properties.map((property, index) => (
                
                <FlexRow key={`prop-row-${property.key}`} gap={8} >
                    <TextInput
                        id={`prop-value-${index}`}
                        label={property.key}
                        placeholderText="Property Value"
                        value={property.value}
                        onChange={(val) => {
                            onPropertyDataChanged?.(
                                properties.map((p) =>
                                    p.key === property.key
                                        ? {
                                                key: property.key,
                                                value: val,
                                            }
                                        : p
                                )
                            );
                        }}
                    />
                    <FlexColumn style={{justifyContent: "end"}} width="auto">
                        <Button
                            label="X"
                            onClick={() => {
                                onPropertyDataChanged?.(
                                    properties.filter(
                                        (prop) => prop.key !== property.key
                                    )
                                );
                            }}
                        />
                    </FlexColumn>
                </FlexRow>
                
            ))}
            <FlexRow alignment="end" width="full">
                <FlexRow alignment="center" gap={8} width="quarter">
                    <TextInput
                        value={newPropertyText}
                        placeholderText="Add Property..."
                        onChange={(val) => {
                            setNewPropertyText(val);
                        }}
                    />
                    <Button
                        label="+"
                        onClick={() => {
                            onPropertyDataChanged?.([
                                ...properties,
                                { key: newPropertyText, value: "" },
                            ]);
                        }}
                        disabled={
                            newPropertyText.trim().length <= 0 ||
                            Object.keys(properties).includes(newPropertyText)
                        }
                    />
                </FlexRow>
            </FlexRow>
        </FlexColumn>
    );
}
